import { MAZE_EMOJIS } from '../config/mazeEmojis';

export interface MazeImagePair {
  start: string;  // Изображение для начала лабиринта
  finish: string; // Изображение для конца лабиринта
}

// Getters read MAZE_EMOJIS at access time so admin-configured values
// (applied via setMazeEmojis) propagate to consumers — copying the strings
// at module init froze them to the fallback values.
const dynamicPair = {} as MazeImagePair;
Object.defineProperty(dynamicPair, 'start', {
  get: () => MAZE_EMOJIS.entrance,
  enumerable: true,
});
Object.defineProperty(dynamicPair, 'finish', {
  get: () => MAZE_EMOJIS.exit,
  enumerable: true,
});

export const mazeImagePairs: MazeImagePair[] = [dynamicPair];
